export const visit = (vm, at) => {
at({ "en": { "conversations-inbox-message-history": { "responder": { "automatic": "Automated", "bot": "Bot", "unknownResponder": "Unknown user", "unknownSender": "Unknown sender", "unknownVisitor": "Unknown visitor", "feedbackSubmission": "Feedback Submission" } } } });
};